export var Manifest;
(function (Manifest) {
    Manifest["MPD"] = "mpd";
    Manifest["M3U8"] = "m3u8";
})(Manifest || (Manifest = {}));
